import { createComponent } from '@helpers/admin';
import component from '@template/blocks/domain/DomainNameTldSearch';
import store from '@/redux/store.ts';

export const DomainNameTldSearch = createComponent({
  label: 'TLD Search',
  component,
  resolveFields: () => {
    const state = store.getState();
    const { tlds, loaded } = state.store.tlds.tlds;
    return {
      input: {
        label: 'Input',
        type: 'input',
      },
      submit: {
        label: 'Button',
        type: 'button',
      },
      tlds: {
        label: 'TLDs',
        type: 'array',
        arrayFields: {
          tld: {
            label: 'TLD',
            type: 'select',
            search: true,
            disabled: !loaded,
            options: tlds.map((tld) => ({
              label: `.${tld.name.toUpperCase()}`,
              value: tld.id,
            })),
          },
        },
      },
      availableTitle: {
        label: 'Available Title',
        type: 'textarea',
        default: 'Available Domains',
      },
      unavailableTitle: {
        label: 'Unavailable Title',
        type: 'textarea',
        default: 'Unavailable Domains',
      },
    };
  },
});
